import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-tryout-active-billing-programs',
  templateUrl: './tryout-active-billing-programs.component.html',
  styleUrls: ['./tryout-active-billing-programs.component.css']
})
export class TryoutActiveBillingProgramsComponent implements OnInit {

  @Input() NoOfActiveBillingPrograms: string;
  @Output() filterProgramsEvent = new EventEmitter();

  program_status = '';

  constructor() { }

  ngOnInit() {
  }

  filterProgramListing(value) {
    this.program_status = value;
    this.filterProgramsEvent.emit(this.program_status);
  }
}



// WEBPACK FOOTER //
// ./src/app/tryout/components/tryout-active-billing-programs/tryout-active-billing-programs.component.ts